import { Box, SxProps, Theme, useMediaQuery, useTheme } from '@mui/material';

import NavbarLayout from './NavbarLayout';
import NavbarMobileLayout from './NavbarMobileLayout';

const getStyles = (theme: Theme): { [key: string]: SxProps } => {
  return {
    wrapper: {
      display: 'flex',
      flexDirection: 'column',
      zIndex: 4,
      background: theme.palette.background.default,
    },
  };
};

export default function NavbarWrapperLayout() {
  const theme = useTheme();
  const styles = getStyles(theme);

  const matches = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box sx={styles.wrapper} className="print-hidden">
      {matches && <NavbarMobileLayout />}
      {!matches && <NavbarLayout />}
    </Box>
  );
}
